import { StatusIcon } from '../../..'

import styles from './Spinner.module.scss'

export const Spinner = () => <StatusIcon className={styles.navbarSpinner} spin />
